import React from 'react';
import './Band.css';
import Musician from './musician/Musician';

import pic_jan from '../../images/pic_jan.jpg';
import pic_michi from '../../images/pic_michael.jpg';
import pic_motiz from '../../images/pic_motiz.jpg';
import pic_simon from '../../images/pic_simon.jpg';
import pic_svenia from '../../images/pic_svenia.jpg';

class Band extends React.Component {
  render() {

    const title_jan = 'Jan Rensing'
    const title_michi = 'Michael Ostendorf'
    const title_motiz = 'Moritz Meier'
    const title_simon = 'Simon Hassels'
    const title_svenia = 'Svenia Ribeiro'

    return (
      <div className="band">
        <div className="band-padding">
          <div className="grid-container">
            <div className="grid-item">
              <Musician 
                image = {pic_svenia}
                title = {title_svenia}
              />
            </div>
            <div className="grid-item">
              <Musician 
                image = {pic_motiz}
                title = {title_motiz}
              />
            </div>
            <div className="grid-item">
              <Musician 
                image = {pic_michi}
                title = {title_michi}
              />
            </div>
            <div className="grid-item">
              <Musician 
                image = {pic_simon}
                title = {title_simon}
              />
            </div>  
            <div className="grid-item">
              <Musician 
                image = {pic_jan}
                title = {title_jan}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Band;


// WEBPACK FOOTER //
// ./src/components/band/Band.js